export default __webpack_public_path__ + "static/media/instant-gratification-overlay.75e8c32e.svg";